import React, { useEffect } from "react";
import { Modal, Input, Select, Form } from "antd";

export const RegionDlg = ({ model, regionDirectors, save, visible, saving, close, check }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(model);
  }, [model, form]);

  const onSave = () => {
    form.validateFields().then((values) => {
      save(values);
    });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal title="Region" visible={visible} maskClosable={false} onOk={onSave} confirmLoading={saving} onCancel={close}>
      <Form form={form} {...layout} initialValues={{ ...model }}>
        <Form.Item
          label="Region Name"
          name="name"
          hasFeedback
          validateTrigger={["onBlur", "onChange"]}
          rules={[
            { required: true, message: "Please input region name!" },
            ({ getFieldValue }) => ({
              validateTrigger: "onBlur",
              validator(_, value) {
                if (!value) return Promise.resolve();
                return check(value).then((msg) => {
                  if (msg) return Promise.reject(new Error(msg));
                  return Promise.resolve();
                });
              },
            }),
          ]}
        >
          <Input placeholder="Enter region name" />
        </Form.Item>
        <Form.Item label="Directors" name="directorIds" rules={[{ required: true }]}>
          <Select mode="multiple">
            {regionDirectors.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
